import type { ListProps } from "components/List"

type LinksWithLocale = {
  heading: string
  items: {
    href: {
      "en-GB": string
      "en-US"?: string
    }
    label: string
  }[]
}

export const sortLinksByLocale = (
  locale: string,
  linksToSort: LinksWithLocale[]
): ListProps[] => {
  return linksToSort.map((link) => {
    return {
      heading: link.heading,
      items: link.items.map((item) => {
        return {
          href: item.href["en-US"] ? item.href[locale] : item.href["en-GB"],
          label: item.label,
        }
      }),
    }
  })
}
